export default __webpack_public_path__ + "static/media/carlton.6d025f61.gif";